var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgOpenModal = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 2.375a.625.625 0 0 1 .625-.625h10a.625.625 0 0 1 .625.625v11.25a.624.624 0 0 1-.625.625h-10a.625.625 0 0 1-.625-.625v-2.5a.625.625 0 1 0-1.25 0v2.5A1.875 1.875 0 0 0 7.125 15.5h10A1.875 1.875 0 0 0 19 13.625V2.375A1.875 1.875 0 0 0 17.125.5h-10A1.875 1.875 0 0 0 5.25 2.375v2.5a.625.625 0 0 0 1.25 0v-2.5Z",
    fill: "#2E2E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.818 8.443a.625.625 0 0 0 0-.885l-3.75-3.75a.626.626 0 1 0-.886.885l2.684 2.682H.875a.625.625 0 1 0 0 1.25h10.991l-2.684 2.682a.626.626 0 1 0 .886.886l3.75-3.75Z",
    fill: "#2E2E2E"
  })));
};
export { SvgOpenModal as ReactComponent };
export default __webpack_public_path__ + "6ef78904b522e56de5448fcd53c92199.svg";